import { render, staticRenderFns } from "./campus-manage.vue?vue&type=template&id=42e4e3cd&scoped=true"
import script from "./campus-manage.vue?vue&type=script&lang=js"
export * from "./campus-manage.vue?vue&type=script&lang=js"
import style0 from "./campus-manage.vue?vue&type=style&index=0&id=42e4e3cd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e4e3cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e4e3cd')) {
      api.createRecord('42e4e3cd', component.options)
    } else {
      api.reload('42e4e3cd', component.options)
    }
    module.hot.accept("./campus-manage.vue?vue&type=template&id=42e4e3cd&scoped=true", function () {
      api.rerender('42e4e3cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/campus-manage.vue"
export default component.exports